import React from "react";
import { Field } from "react-final-form";
import { SelectAdapter } from "@soqs/common";

const DropDownSelectComponent = (props) => {
  let { required, optionsloading, label } = props;

  if (optionsloading === undefined) {
    optionsloading = false;
  }
  if (required === undefined) {
    required = false;
  }
  if (label === undefined) {
    label = "provide a label";
  }

  const isRequired = (value) => {
    if (!required) return undefined;

    const empty =
      value === undefined ||
      value === null ||
      value === "" ||
      (Array.isArray(value) && value.length === 0);

    return empty ? `A ${label} must be selected` : undefined;
  };

  return (
    <Field
      required={required}
      label={label}
      fullWidth
      validate={isRequired}
      component={SelectAdapter}
      loading={optionsloading}
      subscription={{ touched: true, value: true, error: true }}
      {...props}
    />
  );
};

export default DropDownSelectComponent;
